// Catalog.ID Client — Letterhead
// ============================================================================
// The Catalog letterhead is the designer-owned SVG artwork in design/ (text
// already outlined; CSS classes in an inline <style>, which pdfmake's bundled
// svg-to-pdfkit resolves). It is painted by pdfmake itself as the page
// `background`, scaled to the page — no post-processing, so the artwork lands
// exactly where the designer put it. Updating the letterhead is a file swap.
//
//  - letterhead.svg            header + footer (first page / separable pages)
//  - letterhead-continued.svg  footer only (continuation pages of a letter)
//  - coverpage.svg             the kit cover: the lockup alone, page 1 of a kit

import type { TDocumentDefinitions } from 'pdfmake/interfaces';
import letterheadSvg from '../../../../../design/letterhead.svg?raw';
import letterheadContinuedSvg from '../../../../../design/letterhead-continued.svg?raw';
import coverSvg from '../../../../../design/coverpage.svg?raw';
import { makeCoverBackground, makeLetterheadBackground } from './letterhead-background';

export { LETTERHEAD_PAGE_MARGINS_A4, LETTERHEAD_PAGE_MARGINS_A5 } from './letterhead-background';
export type { LetterheadBackground, LetterheadMode } from './letterhead-background';

export const LETTERHEAD_SVG: string = letterheadSvg;
export const LETTERHEAD_CONTINUED_SVG: string = letterheadContinuedSvg;
export const COVER_SVG: string = coverSvg;

/** Stationery: header + footer on page 1, footer only afterwards. */
export const letterheadBackground = makeLetterheadBackground(LETTERHEAD_SVG, LETTERHEAD_CONTINUED_SVG, 'stationery');

/** Header + footer on every page — for documents whose pages get separated. */
export const letterheadEveryPage = makeLetterheadBackground(LETTERHEAD_SVG, LETTERHEAD_CONTINUED_SVG, 'every-page');

/** The kit cover (design/coverpage.svg, 2026-09-08) — page 1 of every kit,
 *  bound by `buildBookletDefinition` when the print options say the first
 *  page is a cover. Never the background of a single-sheet reprint. */
export const kitCoverBackground = makeCoverBackground(COVER_SVG);

/** Give a doc-definition the stationery letterhead unless it brought its own background. */
export function withLetterhead(dd: TDocumentDefinitions): TDocumentDefinitions {
    if (dd.background) return dd;
    return { ...dd, background: letterheadBackground };
}
